interface PathParams { [key: string]: string }

/**
 * Builds a path-matching regular expression from a route template.
 *
 * @param path - The path template to convert.
 * @param params - Optional parameter substitutions for named segments.
 * @returns A regular expression that matches the path template.
 * @example
 * const regex = createPathRegex('/administrace/uzivatele/:id', {id: '123'});
 */
export const createPathRegex = (path: string, params?: PathParams): RegExp => {
    const regexString = path.replace(/:([^/]+)/g, (_, paramName) => {
        const paramValue = params?.[paramName];
        return paramValue !== undefined ? paramValue : '[^/]+';
    });

    return new RegExp(`^${regexString}`);
};
